"use client";
import ComponentTraverser from "components/ComponentTraverser/ComponentTraverser";
import PageLayout from "components/PageLayout/PageLayout";
import FrontPage from "components/TypeLayouts/FrontPage";
import ProductPage from "components/TypeLayouts/ProductPage";
import CategoryPage from "components/TypeLayouts/CategoryPage";
import { filter_gutenberg_blocks } from "hooks/utils/gutenberg";

const PageLayouts = ({ type_page, page, categories, productPropertiesLookup, preparation_packages, allFilters }) => {
  const gutenberg = page?.gutenberg || [];

  const filter_gutenberg =
    gutenberg?.length < 0
      ? [filter_gutenberg_blocks(gutenberg)]
      : filter_gutenberg_blocks(gutenberg);

  const post_title = page?.post_title;
  const hide_title = page?.acf_fields?.titel_verbergen;

  if (type_page === "front") {
    return (
      <FrontPage 
        page={page} 
      />
    );
  } else if (type_page === "product") {
    return (
      <ProductPage
        page={page}
        preparation_packages={preparation_packages}
      />
    );
  } else if (type_page === "cat") {
    //create propertie lookup end extend products with extra lookup
    const { lookup: product_properties_lookup, extended_products: products } = productPropertiesLookup || { lookup: {}, extended_products: [] };

    return (
      <CategoryPage
        page={page}
        products={products}
        categories={categories}
        product_properties_lookup={product_properties_lookup}
        filters={allFilters}
      />
    );
  } 
  return (
    <PageLayout breadcrumbs={[{ name: post_title }]}>
      {filter_gutenberg?.map((item, idx) => {
        return (
          <ComponentTraverser
            data={item}
            key={idx}
            post_title={post_title}
            hide_title={hide_title}
          />
        );
      })}
    </PageLayout>
  );
  
};

export default PageLayouts;
